import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { MUTED, WARNING_HINT } from '../common/tokens';
import {
  DISABLED_BG, TagEditButton, TagEditIcon, TagEditShell, tagEditHintSx, tagEditInputSx,
} from '../common/TagEditChip';
import MergeBanner from './MergeBanner';

/**
 * The chip in rename mode: the name under edit, its count, and confirm/cancel.
 */
export default function RenameForm({
  tag, value, isDirty, conflictName, showMerge,
  inputRef, onChange, onKeyDown, onBlur, onSubmit, onCancel,
  onConfirmMerge, onDismissMerge,
}) {
  const theme = useTheme();
  const showCount = tag.count != null;

  return (
    <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <TagEditShell>
        <TagEditIcon />
        <Box
          component="input"
          ref={inputRef}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          sx={tagEditInputSx(value.length, 80)}
        />
        {showCount && (
          <Box
            component="span"
            sx={{
              fontSize: 11,
              fontWeight: 700,
              color: '#fff',
              background: '#bbb',
              padding: '0 7px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              borderLeft: '1px solid rgba(0,0,0,0.08)',
              flexShrink: 0,
            }}
          >
            {tag.count.toLocaleString('en-US')}
          </Box>
        )}
        <TagEditButton
          type="button"
          aria-label="Confirm rename"
          // mousedown rather than click: the input must not blur first.
          onMouseDown={(e) => { e.preventDefault(); onSubmit(); }}
          sx={{
            background: isDirty ? theme.palette.success.main : DISABLED_BG,
            color: '#fff',
            padding: '0 8px',
            cursor: isDirty ? 'pointer' : 'default',
            borderLeft: '1px solid rgba(0,0,0,0.08)',
            transition: 'background 0.15s',
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </TagEditButton>
        <TagEditButton
          type="button"
          aria-label="Cancel rename"
          onMouseDown={(e) => { e.preventDefault(); onCancel(); }}
          sx={{ background: 'transparent', color: MUTED, padding: '0 7px' }}
        >
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </TagEditButton>
      </TagEditShell>

      {conflictName && !showMerge && (
        <Box sx={{ ...tagEditHintSx, color: WARNING_HINT }}>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          Tag already exists — press Enter to merge
        </Box>
      )}

      {showMerge && (
        <MergeBanner
          targetTag={tag.name}
          newName={conflictName}
          onConfirm={onConfirmMerge}
          onCancel={onDismissMerge}
        />
      )}
    </Box>
  );
}
